/**
 * Modifies the muiTheme with the options from customTheme
 *
 * @param {object} muiTheme
 * @param {object} customTheme
 */

export const modifyMui = muiTheme => {
  return muiTheme
}
